<html>

    <body class="dx-viewport">
       
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->  
        <dx-box
            direction="row"
            width="100%"
            [height]="formheight"
        >
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="1.0"
            >   
                <span style="width: 100%; font-size: 16px; font-weight: 700; text-align: center">Invitee Undecided</span>

                <dx-data-grid 
                    #gridinviteeundecided
                    id="gridinviteeundecided"

                    keyExpr="id"
                    [dataSource]="subscriptioninviteeundecidedlist"   

                    [allowColumnReordering]="false"
                    [allowColumnResizing]="true"
                    [showRowLines]="true"
                    [showColumnLines]="false"
                    [showBorders]="true"
                    [repaintChangesOnly]="true"

                    [focusedRowEnabled]="true"
                    [hoverStateEnabled]="true"
                    [autoNavigateToFocusedRow]="true"

                    width="98%"
                    height="94%"
                >
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxo-filter-row
                        [visible]="true"
                    >
                    </dxo-filter-row>

                    <dxo-summary>
                        <dxi-total-item
                            column="firstname"
                            displayFormat="Invitee still Undecided: {0}"
                            summaryType="count">
                        </dxi-total-item>
                    </dxo-summary>    
                    
                    <dxo-row-dragging

                        data="subscriptioninviteeundecidedlist"
                       
                        group="tasks"

                        [showDragIcons]="true"

                        [onAdd]="onAdd"
                        [onDragStart]="onDragStartInviteeName"
t
                        dragTemplate="myDragTemplate"
                    >
                    
                        <div *dxTemplate="let e of 'myDragTemplate'">
                            {{ e.itemData.firstname}}&nbsp;{{ e.itemData.lastname}} 
                        </div>        
                    
                    </dxo-row-dragging>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxi-column
                        dataField="id"
                        caption="id"
                        [allowEditing]="false" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >
                    </dxi-column>   

                    <dxi-column
                        dataField="whoseparticipant"
                        caption="Whose Guest"
                        [allowEditing]="true" 
                        [allowSorting]="false"
                        [allowFiltering]="false"
                        [visible]="true"
                        width="19%"

                        groupCellTemplate="cellparticipantname"
                        [groupIndex]="0"

                    >

                         <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->    
                         <div *dxTemplate="let d of 'cellparticipantname'">
                            <div>{{whoseguest | getinitial: d.value: whoseguest.length: 10 }}</div> 
                        </div>  
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 

                    </dxi-column>  

                    <dxi-column
                        dataField="title"
                        caption="Title"
                        [allowEditing]="false" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"
                    >

                    </dxi-column>   

                    <dxi-column
                        dataField="lastname"
                        caption="Last Name"
                        [allowEditing]="false" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"
                    >

                    </dxi-column>

                    <dxi-column
                        dataField="firstname"
                        caption="First Name"
                        [allowEditing]="false" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"
                    >

                    </dxi-column>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                </dx-data-grid>

            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="1.0"
            >
                 <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->  
                <dx-box
                    direction="col"
                    width="100%"
                    height="100%"
                >

                        <dxi-item
                            [ratio]="1.0"
                        >
                            <span style="width: 100%; font-size: 16px; font-weight: 700; text-align: center">Invitee Coming</span>
                           
                            <dx-data-grid 
                                #gridinviteenconfirm
                                id="gridinviteeconfirm"

                                keyExpr="id"
                                [dataSource]="subscriptioninviteeconfirmlist"   
                            
                                [allowColumnReordering]="false"
                                [allowColumnResizing]="true"
                                [showRowLines]="true"
                                [showColumnLines]="false"
                                [showBorders]="true"
                                [repaintChangesOnly]="true"

                                [focusedRowEnabled]="true"
                                [hoverStateEnabled]="true"
                                [autoNavigateToFocusedRow]="true"

                                width="100%"
                                height="88%"
                            >
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxo-filter-row
                                [visible]="true"
                            >
                            </dxo-filter-row>

                            <dxo-summary>
                                <dxi-total-item
                                    column="firstname"
                                    displayFormat="Invitee Coming: {0}"
                                    summaryType="count">
                                </dxi-total-item>
                            </dxo-summary>    
                            
                            <dxo-row-dragging
                                
                                    data="subscriptioninviteeconfirmlist"
                                
                                    group="tasks"

                                    [showDragIcons]="true"

                                    [onAdd]="onAdd"
                                    [onDragStart]="onDragStartInviteeName"

                                    dragTemplate="myDragTemplate"
                                >
                                
                                    <div *dxTemplate="let e of 'myDragTemplate'">
                                        {{ e.itemData.firstname}}&nbsp;{{ e.itemData.lastname}}
                                    </div>        
                                
                                </dxo-row-dragging>
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxi-column
                                dataField="id"
                                caption="id"
                                [allowEditing]="false" 
                                [allowSorting]="false"
                                [visible]="false"
                                width="19%"
                            >
                            </dxi-column>   

                            <dxi-column
                                dataField="whoseparticipant"
                                caption="Whose Guest"
                                [allowEditing]="true" 
                                [allowSorting]="false"
                                [allowFiltering]="false"
                                [visible]="true"
                                width="19%"

                                groupCellTemplate="cellparticipantname"
                                [groupIndex]="0"
        
                            >

                                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->    
                                <div *dxTemplate="let d of 'cellparticipantname'">
                                    <div>{{whoseguest | getinitial: d.value: whoseguest.length: 10 }}</div> 
                                </div>  
                                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 

                            </dxi-column>  

                            <dxi-column
                                dataField="title"
                                caption="Title"
                                [allowEditing]="false" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >

                            </dxi-column>   

                            <dxi-column
                                dataField="lastname"
                                caption="Last Name"
                                [allowEditing]="false" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >
                            
                            </dxi-column>

                            <dxi-column
                                dataField="firstname"
                                caption="First Name"
                                [allowEditing]="false" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >

                            </dxi-column>

                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        </dx-data-grid>
                    </dxi-item>
                     <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxi-item
                    [ratio]="0.01"
                    >
                    
                    </dxi-item>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxi-item
                        [ratio]="1.0"
                    >
                        
                        <span style="width: 100%; font-size: 16px; font-weight: 700; text-align: center">Invitee Not Coming</span>
                        
                        <dx-data-grid 
                            #gridinviteennotcoming
                            id="gridinviteennotcoming"

                            keyExpr="id"
                            [dataSource]="subscriptioninviteenotcominglist"   
                        
                            [allowColumnReordering]="false"
                            [allowColumnResizing]="true"
                            [showRowLines]="true"
                            [showColumnLines]="false"
                            [showBorders]="true"
                            [repaintChangesOnly]="true"

                            [focusedRowEnabled]="true"
                            [hoverStateEnabled]="true"
                            [autoNavigateToFocusedRow]="true"

                            width="100%"
                            height="88%"
                        >
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxo-filter-row
                                [visible]="true"
                            >
                            </dxo-filter-row>

                            <dxo-summary>
                                <dxi-total-item
                                    column="firstname"
                                    displayFormat="Invitee not Coming: {0}"
                                    summaryType="count">
                                </dxi-total-item>
                            </dxo-summary>    

                            <dxo-row-dragging
                                
                                    data="subscriptioninviteenotcominglist"
                                
                                    group="tasks"

                                    [showDragIcons]="true"

                                    [onAdd]="onAdd"
                                    [onDragStart]="onDragStartInviteeName"

                                    dragTemplate="myDragTemplate"
                                >
                                
                                    <div *dxTemplate="let e of 'myDragTemplate'">
                                        {{ e.itemData.firstname}}&nbsp;{{ e.itemData.lastname}}
                                    </div>        
                                
                                </dxo-row-dragging>
                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                            <dxi-column
                                dataField="id"
                                caption="id"
                                [allowEditing]="false" 
                                [allowSorting]="false"
                                [visible]="false"
                                width="19%"
                            >
                            </dxi-column>   

                            <dxi-column
                                dataField="whoseparticipant"
                                caption="Whose Guest"
                                [allowEditing]="true" 
                                [allowSorting]="false"
                                [allowFiltering]="false"
                                [visible]="true"
                                width="19%"

                                groupCellTemplate="cellparticipantname"
                                [groupIndex]="0"
        
                            >

                                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->    
                                <div *dxTemplate="let d of 'cellparticipantname'">
                                    <div>{{whoseguest | getinitial: d.value: whoseguest.length: 10 }}</div> 
                                </div>  
                                <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 

                            </dxi-column>  

                            <dxi-column
                                dataField="title"
                                caption="Title"
                                [allowEditing]="false" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >
                            </dxi-column>   

                            <dxi-column
                                dataField="lastname"
                                caption="Last Name"
                                [allowEditing]="false" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >
                            </dxi-column>

                            <dxi-column
                                dataField="firstname"
                                caption="First Name"
                                [allowEditing]="false" 
                                [allowSorting]="false"
                                [visible]="true"
                                width="19%"
                            >
                            </dxi-column>

                            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                        </dx-data-grid>
                   
                    </dxi-item>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                </dx-box>

            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->

        </dx-box>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    </body>

</html>

